import { render } from "./myChat.vue?vue&type=template&id=77793f1e&scoped=true"
import script from "./myChat.vue?vue&type=script&lang=js"
export * from "./myChat.vue?vue&type=script&lang=js"

import "./myChat.vue?vue&type=style&index=0&id=77793f1e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77793f1e"]])

export default __exports__